<div class="loader-wrapper" *ngIf="loader.loaderEnabled">
  <div class="backdrop"></div>
  <div class="spinner"></div>
</div>
